export var BiometryType;
(function (BiometryType) {
    BiometryType[BiometryType["NONE"] = 0] = "NONE";
    BiometryType[BiometryType["TOUCH_ID"] = 1] = "TOUCH_ID";
    BiometryType[BiometryType["FACE_ID"] = 2] = "FACE_ID";
    BiometryType[BiometryType["FINGERPRINT"] = 3] = "FINGERPRINT";
    BiometryType[BiometryType["FACE_AUTHENTICATION"] = 4] = "FACE_AUTHENTICATION";
    BiometryType[BiometryType["IRIS_AUTHENTICATION"] = 5] = "IRIS_AUTHENTICATION";
})(BiometryType || (BiometryType = {}));
